import React from 'react'
import { Box, Switch, Typography } from '@material-ui/core'

interface PauseResumeControlProps {
    isLive: boolean
    isLoading: boolean
    onPause: () => void
    onResume: () => void
}

export const PauseResumeControl: React.FC<PauseResumeControlProps> = ({
    isLive,
    isLoading,
    onPause,
    onResume,
}) => (
    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
        <Typography variant="body2" color="textSecondary">
            {isLive ? 'Answering calls' : 'Paused'}
        </Typography>
        <Switch
            color="primary"
            checked={isLive}
            disabled={isLoading}
            onChange={() => (isLive ? onPause() : onResume())}
            inputProps={{
                'aria-label': isLive ? 'Pause agent' : 'Resume agent',
            }}
        />
    </Box>
)
